/** CFA BigCommerce stores display calendar dates in US Eastern. */
export const BIGCOMMERCE_STORE_TIMEZONE = 'America/New_York';

const CALENDAR_DATE_PATTERN = /^(\d{4})-(\d{2})-(\d{2})/;

/**
 * Formats a BigCommerce timestamp as the calendar date shown in BC admin.
 */
export function formatBigCommerceCalendarDate(
  dateString: string | null | undefined,
): string {
  if (!dateString?.trim()) {
    return 'N/A';
  }

  const trimmed = dateString.trim();
  const dateOnlyMatch = trimmed.match(CALENDAR_DATE_PATTERN);
  if (dateOnlyMatch && trimmed.length === 10) {
    const year = Number(dateOnlyMatch[1]);
    const month = Number(dateOnlyMatch[2]);
    const day = Number(dateOnlyMatch[3]);
    return new Date(Date.UTC(year, month - 1, day)).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      timeZone: 'UTC',
    });
  }

  const parsed = new Date(trimmed);
  if (Number.isNaN(parsed.getTime())) {
    return 'N/A';
  }

  return parsed.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    timeZone: BIGCOMMERCE_STORE_TIMEZONE,
  });
}
